module.exports = __webpack_public_path__ + "static/media/productIntroForm4.1387ca2c.jpg";